/*
===============================================================
  ____    ___    ____   _   __       __                
 |  _ |  / _ \  |  _ \ | | |   \    |   \  ___  __ __  
 |  __| | |_| | |  __/ | | | |) | o | |) |/ -_) \ V /  
 |_|\_\ |_| |_| |_|    |_| |___/    |___/ \___|  \_/    o o o   

===============================================================

  // You can declare that a prop is a specific JS type. By default, these
  // are all optional.
  optionalArray: PropTypes.array,
  optionalBool: PropTypes.bool,
  optionalFunc: PropTypes.func,
  optionalNumber: PropTypes.number,
  optionalObject: PropTypes.object,
  optionalString: PropTypes.string,
  optionalSymbol: PropTypes.symbol,

  // Anything that can be rendered: numbers, strings, elements or an array
  // (or fragment) containing these types.
  optionalNode: PropTypes.node,

  // A React element.
  optionalElement: PropTypes.element,

  // A React element type (ie. MyComponent).
  optionalElementType: PropTypes.elementType,

  // You can also declare that a prop is an instance of a class. This uses
  // JS's instanceof operator.
  optionalMessage: PropTypes.instanceOf(Message),

  // You can ensure that your prop is limited to specific values by treating
  // it as an enum.
  optionalEnum: PropTypes.oneOf(['News', 'Photos']),

  // An object that could be one of many types
  optionalUnion: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Message)
  ]),

  // An array of a certain type
  optionalArrayOf: PropTypes.arrayOf(PropTypes.number),

  // An object with property values of a certain type
  optionalObjectOf: PropTypes.objectOf(PropTypes.number),

  // An object taking on a particular shape
  optionalObjectWithShape: PropTypes.shape({
    color: PropTypes.string,
    fontSize: PropTypes.number
  }),

  // An object with warnings on extra properties
  optionalObjectWithStrictShape: PropTypes.exact({
    name: PropTypes.string,
    quantity: PropTypes.number
  }), 
*/

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React examples
import { Divider, FormGroup } from "@mui/material";

function TaskMenu({ data, checkValue, setValue }) {
  const [checked, setChecked] = useState([...checkValue]);

  const handleToggle = (value) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    // console.log(newChecked);
    setChecked(newChecked);
    setValue(newChecked);
  };

  useEffect(() => {
    setChecked([...checkValue]);
  }, [checkValue]);

  return (
    <MDBox sx={{ minWidth: 650 }}>
      {data.map((row) => (
        <Grid container spacing={2} key={row.main.id}>
          <Grid item xs={3}>
            {row.main.title}
          </Grid>
          <Grid item xs={9}>
            <FormGroup aria-label="position" row>
              {row.data.map((value) => (
                <FormControlLabel
                  key={value.id}
                  control={
                    <Checkbox
                      checked={checked.indexOf(value.id) !== -1}
                      tabIndex={-1}
                      onClick={() => handleToggle(value.id)}
                    />
                  }
                  label={value.title}
                />
              ))}
            </FormGroup>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
        </Grid>
      ))}
    </MDBox>
  );
}

TaskMenu.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  checkValue: PropTypes.arrayOf(PropTypes.node).isRequired,
  setValue: PropTypes.func.isRequired,
};

export default TaskMenu;
